// Librerias
import React from 'react'
import { AutoSizer, Table, Column } from 'react-virtualized'
// API
import api from '../../apiClient/v1'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from './modal.css'
let css = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = { visible: false }
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalDetalle extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false,
            unidades: '',
            notaCredito: false,
            total: '',
            totalAnterior: '',
            sumaCliente: '',
            unidadesAnterior: '',
            totalConIVA: '',
            mes: this.props.mes,
            aprobadoFacturar: false
        }
        this.fetchDetalleFactura = ()=>{
            api.facturacionSaldo().getDetalleSaldo(this.state.mes)
                .then(detalle=>{
                    this.setState({unidades: detalle.unidades})
                    this.setState({total: detalle.total})
                    this.setState({totalAnterior: detalle.totalAnterior})
                    this.setState({sumaCliente: detalle.sumaCliente})
                    this.setState({unidadesAnterior: detalle.unidadesAnterior})
                    this.setState({notaCredito: detalle.notaCredito})
                    this.setState({totalConIVA: detalle.totalConIVA})
                    this.setState({aprobadoFacturar: detalle.aprobadoFacturar})
                })
                .catch(error=>{console.log("error")})
        }
        this.handleSubmit = (evt)=>{
            this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=>{
                this.props.generarFactura()
                    .then(()=>{
                        this.setState({bloqueado: false})
                        this.props.hideModal()
                    })
                    .catch(error=>{
                    console.log("error")
                    })
            })
        }
    }
    componentWillMount() {
        this.fetchDetalleFactura()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={css('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Información de facturación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={'list-group'}>
                        <strong>Unidades</strong>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.state.unidadesAnterior}</span>
                            Unidades facturadas anteriormente 
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.state.sumaCliente}</span>
                            Total unidades contadas
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.state.unidades}</span>
                            Saldo unidades a facturar
                        </li>
                    </ul>
                    <strong>Valores</strong>
                    <ul className={'list-group'}>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.state.totalAnterior}</span>
                            Valor facturado anteriormente
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.state.total}</span>
                            {this.state.notaCredito?'Valor de nota de credito': 'Valor neto'}
                        </li>
                        {this.state.notaCredito?
                            <div></div>
                            :
                            <li className={'list-group-item'}>
                                <span className={'badge'}>${this.state.totalConIVA}</span>
                                Valor bruto
                            </li>
                        }
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    {this.props.permisos.aprobarUndSEI?
                        <form onSubmit={this.handleSubmit}>
                            <button type={'submit'} className={'btn btn-primary'} disabled={!!(this.state.bloqueado == true || this.state.aprobadoFacturar == false)}>{'Facturar'}</button>
                            <button type={'submit'} className={'btn btn-primary'} disabled={!!(this.state.bloqueado == true || this.state.notaCredito == false)}>{'Nota Credito'}</button>
                            <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cancelar</button>
                        </form>
                        :
                        <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cerrar</button>
                    }
                </Modal.Footer>
            </Modal>
        )
    }
}
export class ModalDetalleCliente extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false,
            aprobacionInformar: false,
            unidades: '',
            notaCredito: false,
            total: '',
            totalAnterior: '',
            sumaCliente: '',
            unidadesAnterior: '',
            totalConIVA: '',
            mes: this.props.mes,
            aprobadoFacturar: false
        }
        this.fetchDetalleFactura = ()=>{
            api.facturacionSaldo().getDetalleSaldo(this.state.mes)
                .then(detalle=>{
                    this.setState({unidades: detalle.unidades})
                    this.setState({total: detalle.total})
                    this.setState({totalAnterior: detalle.totalAnterior})
                    this.setState({sumaCliente: detalle.sumaCliente})
                    this.setState({unidadesAnterior: detalle.unidadesAnterior})
                    this.setState({notaCredito: detalle.notaCredito})
                    this.setState({totalConIVA: detalle.totalConIVA})
                    this.setState({aprobadoFacturar: detalle.aprobadoFacturar})
                    this.setState({aprobacionInformar: detalle.aprobacionInformar})
                })
                .catch(error=>{console.log("error")})
        }
        this.handleSubmit = (evt)=>{
            this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=>{
                this.props.generarCorreoSEI(this.state.total)
                    .then(()=>{
                        this.setState({bloqueado: false})
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        console.log("error")
                    })
            })
        }
    }
    componentWillMount() {
        this.fetchDetalleFactura()
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={css('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Información de facturación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={'list-group'}>
                        <strong>Unidades</strong>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.state.unidadesAnterior}</span>
                            Unidades facturadas anteriormente
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.state.sumaCliente}</span>
                            Total unidades contadas
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.state.unidades}</span>
                            Saldo unidades a facturar
                        </li>
                    </ul>
                    <strong>Valores</strong>
                    <ul className={'list-group'}>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.state.totalAnterior}</span>
                            Valor facturado anteriormente
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>${this.state.total}</span>
                            {this.state.notaCredito?'Valor de nota de credito': 'Valor neto'}
                        </li>
                        {this.state.notaCredito?
                            <div></div>
                            :
                            <li className={'list-group-item'}>
                                <span className={'badge'}>${this.state.totalConIVA}</span>
                                Valor bruto
                            </li>
                        }
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    {this.props.permisos.aprobarUndCliente?
                        <form onSubmit={this.handleSubmit}>
                            <button type={'submit'} className={'btn btn-primary'} disabled={!!(this.state.bloqueado == true || this.state.aprobacionInformar == false)}>{'Informar aprobación'}</button>
                            <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cancelar</button>
                        </form>
                        :
                        <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cerrar</button>
                    }
                </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/diferencias-inventarios/Modales.jsx